import { useQuery } from '@tanstack/react-query';
import { httpJSON } from '../../../shared/api/http';

export function useGrowthQuery(params = {}) {
  return useQuery({
    queryKey: ['growth', params],
    queryFn: () => httpJSON('/v1/growth', {}, params),
    staleTime: 60_000,
  });
}

